import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { accessKeyStatusChoices } from '@/components/global/options/selectOptions.jsx';
import RefreshIcon from '@/assets/icons/refresh-icon.svg?react';
import DisactiveIcon from '@/assets/icons/disactive-icon.svg?react';
import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import { Box, Typography } from '@mui/material';

const StatusIcon = ({ status }) => {
    switch (status) {
        case 'rotation_pending':
            return <RefreshIcon />;
        case 'revoked':
            return <DisactiveIcon />;
        case 'active':
        default:
            return <ActiveIcon />;
    }
};

StatusIcon.propTypes = {
    status: PropTypes.string,
};

export const StatusField = ({ record }) => {
    const translate = useTranslate();
    const status = accessKeyStatusChoices(translate).find(s => s.id === record.status);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <StatusIcon status={record.status} />
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginLeft: '8px' }}>
                <Typography variant='body2'>{status?.name}</Typography>
            </Box>
        </Box>
    );
};

StatusField.propTypes = {
    record: PropTypes.shape({
        status: PropTypes.string,
    }),
};
